import AkMatrix from "../../../../../spine-appkit-vue/src/components/form/controls/AkMatrix";

const cmsRouteMappingMatrix = AkMatrix;

cmsRouteMappingMatrix.methods.getPrefix = (control, currentValue) => {
    if (currentValue.mappingType === '/' && control.id === 'mappingValue') {
        return currentValue.mappingType;
    }

    return null;
};

Vue.asyncComponent('cms-route-mapping-matrix', cmsRouteMappingMatrix, 'cms/form/controls/cms-route-mapping-matrix.html');
